import type { ReactElement } from 'react';
import { APP_DISPLAY_NAME } from '@mcikm-vote/shared';

import { Logo, useEigenesLogo } from './Logo';

/**
 * Markenkopf der beiden Anmeldeseiten (§9.1, §5.1).
 *
 * Logo und Infotext stehen **zentriert** über dem Eingabefeld. Beide Anmeldeseiten hatten den
 * Kopf zuvor doppelt; er liegt jetzt an einer Stelle, damit Verwaltung und Teilnehmerzugang nicht
 * auseinanderlaufen.
 *
 * Der Anwendungsname steckt als Alternativtext in der Grafik (siehe {@link Logo}) und bleibt damit
 * auch ohne sie lesbar — §9.1 verlangt ihn, nicht das Bild.
 *
 * **Bei einem eigenen Firmenlogo (ÄA-5) erscheint der Name zusätzlich als sichtbarer Text.** Das
 * hochgeladene Logo zeigt den Betreiber, nicht die Anwendung; ohne diese Zeile fiele die
 * „allgemeine Bezeichnung der Anwendung" aus §9.1 ersatzlos weg.
 */
export function Markenkopf({ infotext }: { infotext: string }): ReactElement {
  const eigenesLogo = useEigenesLogo();

  return (
    <header className="text-center">
      <h1>
        {/* `block` ist nötig, damit `mx-auto` an einem Bild greift. */}
        <Logo gross className="mx-auto block" />
        {eigenesLogo !== undefined && (
          <span className="text-text-gedaempft mt-2 block text-sm">{APP_DISPLAY_NAME}</span>
        )}
      </h1>
      <p className="text-text-gedaempft mt-1">{infotext}</p>
    </header>
  );
}
